import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./Modal.css";
import "./KMLInput.css";
import { useDispatch } from "react-redux";
import { slice1Actions } from "../../store/reducer";
import { useSelector } from "react-redux";
import kmlParser from "js-kml-parser";
import { kml, gpx, tcx } from "@tmcw/togeojson";
import Place from "../../Models/Place";
import Group from "../../Models/Group";
import Appointment from "../../Models/Event";
import Places from "../../Models/Places";
import { DateTime } from "luxon";
import GoogleSearch from "../../Models/GoogleSearch";
import GooglePlaces from "../../Models/GooglePlaces";
import { hasRealPhoto } from "../../Common/placeEnrichment";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { usePapaParse } from 'react-papaparse';
import Common, { AICategories, AIBaseCategories } from "../../Common/Common";
import AlertModal from "./AlertModal";
//import MultiSelectModal from "./MultiSelectModal";
//try kml-to-json for creating kml from json

const KMLInput = (props) => {
  const { readString } = usePapaParse();
  // let MultiselectItems = useSelector((state) => state.MultiselectItems);
  // let MultiselectSelectedItems = useSelector((state) => state.MultiselectSelectedItems);
  // let MultiselectMode = useSelector((state) => state.MultiselectMode);
  // let MultiselectSearchText = useSelector((state) => state.MultiselectSearchText);
  // let MultiselectTitle = useSelector((state) => state.MultiselectTitle);
  // let MultiselectCallback = useSelector((state) => state.MultiselectCallback);
  // let ShowMultiselect = useSelector((state) => state.ShowMultiselect);

  const dispatch = useDispatch();
  const [Inputs, SetInputs] = useState([]);
  const [TimeLineJSON, SetTimeLineJSON] = useState({});
  const [AllDates, SetAllDates] = useState([]);
  const [AlertModalShow, setAlertModalShow] = useState(false);
  const [AlertModalTitle, setAlertModalTitle] = useState("");
  const [AlertModalMessage, setAlertModalMessage] = useState("");
  const [AlertModalButtons, setAlertModalButtons] = useState([]);
  const [GroupID, SetGroupID] = useState(0);
  const [visited, setVisited] = useState(false);
  const [ImportOptionsShow, setImportOptionsShow] = useState(false);
  const [optVisited, setOptVisited] = useState(false);
  const [optBucketList, setOptBucketList] = useState(false);
  const pendingImportRef = useRef({ glist: [], filename: "" });
  const [ImportProgress, setImportProgress] = useState("");
  let _GroupID = GroupID;
  let user_info = useSelector((state) => state.user_info);

  const fileInputRef = useRef(null);
  const fileWasPickedRef = useRef(false);

  useEffect(() => {
    SetInputs(props.PromptModalInputs);
  }, [props.PromptModalInputs]);

  useEffect(() => {
    // props.presetFiles — a FileList/File[] already picked by the caller's
    // own synchronous click handler (see MobileBottomNavBar.js/HomeHeader.js/
    // Map.js's openFilePicker) BEFORE this component ever mounted. Newer
    // Chrome versions only honor input[type=file].click() as a real user
    // gesture when it happens synchronously within the original click
    // handler's own call stack — a modal that mounts first and clicks its
    // own hidden input afterward (even via a plain setTimeout(0)) no longer
    // counts, and the picker silently never opens with no error at all.
    // Found 2026-09-27 — reported as "no file dialog" affecting every
    // KML/KMZ/GPX/TCX/CSV/JSON import menu item. When presetFiles is
    // supplied, skip this component's own (now browser-blocked) picker
    // trigger entirely and feed the already-picked files straight to the
    // exact same upload() path a real native picker selection would have.
    if (props.presetFiles) {
      fileWasPickedRef.current = true;
      upload({ target: { files: props.presetFiles } });
      return;
    }
    const timer = setTimeout(() => {
      if (fileInputRef.current) fileInputRef.current.click();
    }, 150);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const input = fileInputRef.current;
    if (!input) return;
    // Dismissing the native file picker without choosing a file fires no
    // "change" event, so without this the modal never calls props.onHide()
    // and KMLInputShow stays stuck true in the parent — the next "Import…"
    // click is then a no-op setState (already true), so this component never
    // remounts and its auto-click effect above never fires again. Chrome
    // fires "cancel" on input[type=file] for exactly this case — but per
    // spec it also fires whenever the picker closes without the file
    // *selection changing* (e.g. picking the same file again), sometimes
    // after "change" has already fired for a real pick. The fileWasPickedRef
    // guard below stops that from killing an in-progress import.
    const handleCancel = () => {
      if (!fileWasPickedRef.current) props.onHide();
    };
    input.addEventListener("cancel", handleCancel);
    return () => input.removeEventListener("cancel", handleCancel);
  }, []);

  const handleButtonClick = (button) => {
    //DirectionshHTML();
    if (button.Method != null) button.Method(result);
    props.onHide();
  };

  //console.log("Inputs", Inputs);
  const upload = async (e) => {
    // Convert the FileList into an array and iterate
    //console.log("e.target.files[0]", e.target.files[0])
    fileWasPickedRef.current = true;

    let files = Array.from(e.target.files).map((file) => {
      // Define a new file reader
      let reader = new FileReader();

      // Create a new promise
      return new Promise((resolve) => {
        // Resolve the promise after reading file
        reader.onload = () => resolve(reader.result);

        // Reade the file as a text
        //reader.readAsText(file);
        parseDocument(file);
      });
    });

    // At this point you'll have an array of results
    await Promise.all(files);
  };

  // const fileChanged = async (e) => {
  //   // file = e.target.files[0];
  //   // parseDocument(file);
  //   Array.from(e.target.files).forEach((file) => {
  //     parseDocument(file);

  //     // // Define a new file reader
  //     // let reader = new FileReader();

  //     // // Function to execute after loading the file
  //     // reader.onload = () => console.log(reader.result);

  //     // // Read the file as a text
  //     // reader.readAsText(file);
  //   });
  // };

  let result = {};

  const parseDocument = async (file) => {
    //console.log("parseDocument props.file_type", props.file_type);        let groups = window.guide_obj.groups;
    

    let fileReader = new FileReader();
    if(props.file_type === "CSV"){
      if (file.name.toUpperCase().endsWith(".CSV")){
        fileReader.onload = function (event) {
          let GroupID = 0;
        let found = false;
        let filename = file.name;
        const fileParts = filename.split('.')
        let groups = window.guide_obj.groups;
        filename = fileParts[0];
            let groupName = filename;
            for (let x = 0; x < groups.length; x++) {
              if (groups[x].name === groupName) {
                found = true;
                GroupID = groups[x].id;
              }
            }
            if(found === false){
              GroupID = window.guide_obj.addGroup(groupName);
                let group = new Group();
                group.id = GroupID;
                group.name = groupName;
                group.poi_img = 16;
                group.mosaic = true;
                // Left unset (not the group's own filename) — this import never
                // creates a matching schedule, so setting .schedule here referenced a
                // schedule that never existed, and Home.js's mosaic-tile click handler
                // ANDs a GroupsFilter with a SchedulesFilter from this field, so every
                // tile for an imported list showed zero places. Leaving it empty routes
                // the tile through the "no linked schedule" path instead, which only
                // filters by group. Found 2026-09-27.
                window.guide_obj.modifyGroup(group, group);
            }
    
            SetGroupID(GroupID);
            const csvOutput = event.target.result;
            const glist = csvToStruct(csvOutput)
            //console.log("glist", glist);
            _GroupID = GroupID;

          pendingImportRef.current = { glist, filename };
          setOptVisited(false);
          setOptBucketList(false);
          setImportOptionsShow(true);

            //setTimeout(() => getMoreInfo(glist), 200);
            
            //getMoreInfo(glist);

          //var url = 'http://www.google.com';
          //var request = require("request");
          // request({ url: glist[0].URL, followRedirect: false }, function (err, res, body) {
          //   console.log(res.headers.location);
          // });
          //fetchURL(glist[0].URL);
        };
        fileReader.readAsText(file)
      }
    }
    else if(props.file_type === "JSON"){
      if (file.name.toUpperCase().endsWith(".JSON")){
        fileReader.onload = function (event) {
          const jsonText = event.target.result;
          let json = JSON.parse(jsonText);
          SetTimeLineJSON(json);
          if(getTimelineDays(json) < 0) {
            alert("No dates found in file");
            return;
          }
          //props.onHide();
          //var url = 'http://www.google.com';
          //var request = require("request");
          // request({ url: glist[0].URL, followRedirect: false }, function (err, res, body) {
          //   console.log(res.headers.location);
          // });
          //fetchURL(glist[0].URL);
        };
        fileReader.readAsText(file)
      }
    }
    else {
    fileReader.onload = async (e) => {
      if (e.target.result.includes(`"guide":`)) {
        parseJSON(e.target.result);
        props.onHide();
        return;
      }
      console.log("e.target.result", e.target.result);
      //const geoJson = kmlParser.toGeoJson(e.target.result);
      let geoJson = {};
      if (file.name.toUpperCase().endsWith(".KML"))
        geoJson = kml(new DOMParser().parseFromString(e.target.result, "text/xml"));
      if (file.name.toUpperCase().endsWith(".GPX")) {
        //const geoJson2 = kmlParser.toGeoJson(e.target.result);
        geoJson = gpx(new DOMParser().parseFromString(e.target.result, "text/xml"));
      }
      if (file.name.toUpperCase().endsWith(".TCX"))
        geoJson = tcx(new DOMParser().parseFromString(e.target.result, "text/xml"));

      //console.log("geoJson", geoJson);
      const fileNameBase = file.name.replace(/\.[^/.]+$/, "");
      const deferred = typeof geoJson.features !== "undefined" && parseGeoJSON(geoJson, fileNameBase);
      if (!deferred) props.onHide();
      //result = await extractGoogleCoords(e.target.result);

      //Do something with result object here
      //console.log(result);
    };
    if (file.name.toUpperCase().endsWith(".KMZ")) {
      var JSZip = require("jszip");
      const kmzFileNameBase = file.name.replace(/\.[^/.]+$/, "");
      JSZip.loadAsync(file).then(function (zip) {
        Object.keys(zip.files).forEach(function (filename) {
          zip.files[filename].async("string").then(function (fileData) {
            //console.log(fileData); // These are your file contents
            const geoJson = kmlParser.toGeoJson(fileData);
            console.log("geoJson", geoJson);
            const deferred = parseGeoJSON(geoJson, kmzFileNameBase);
            if (!deferred) props.onHide();
          });
        });
      });
      //}
      // JSZip.loadAsync(file)
      //   .then(function (content) {
      //     // if you return a promise in a "then", you will chain the two promises
      //     return content.files["css/style.css"].async("text");
      //   })
      //   .then(function (txt) {
      //     alert(txt);
      //   });
    } else fileReader.readAsText(file);
      
    }
  };

  const myConfirm = (message, buttons) => {
    setAlertModalTitle("Confirmation");
    setAlertModalMessage(message);
    setAlertModalButtons(buttons);
    setAlertModalShow(true);
  };
  
let html_entries = [];
  const processImages = (imageList, params) => {
    if (imageList.length === 0) {
      console.log("processImages: error");
      return;
    }
    console.log("processImages: success:", imageList[0].url);
    let place = window.guide_obj.places.getPlace(params.id);
    if (place === null) {
      console.log("processImages: place not found:", params.id);
      return;
    }
    place.Photo = imageList[0].url;
    place.Photo_m = imageList[0].url_m;
    place.Hlink = params.link
    
    const html_entry = `<a href="urllink:${params.link}"><button style="border: none; background: none; border-radius: 10%; font-size: 140%; padding: 5px; background-size: cover;"> <img style="border-radius: 10%;" src="${imageList[0].url_m}" width="336" height="268" /><br />${place.Name}</button></a>`
    
    html_entries.push({name: place.Name, html: html_entry})
    // try {
    //   place.Info = Place.createImageHTML(place.Photo_m, null, "medium"); // + place.Info;
    // } catch (e) {
    //   console.log("processImages: error", e.message);
    // }
  };

    
  const csvToStruct = (csvString) => {
    const GoogleList = [];
    readString(csvString, {
      delimiter: ",",
      complete: (result) => {
        for (let i = 1; i < result.data.length; i++) {
          const row = result.data[i];
          if (!row[0]) continue;
          GoogleList.push({
            Title: row[0],
            Note: row[1] || "",
            URL: row[2] || "",
            Comment: row[3] || "",
          });
        }
      },
    });
    return GoogleList;
  }

  const handleImportOptionsContinue = () => {
    const { glist, filename } = pendingImportRef.current;
    setImportOptionsShow(false);
    getMoreInfo(glist, filename, optVisited, optBucketList);
  };

  const getMoreInfo = (glist, filename, visited, bucketlist) => {
      let GroupID = 0;
      if(bucketlist === false){
        let groups = window.guide_obj.groups;
        let found = false;
        let groupName = filename;
        for (let x = 0; x < groups.length; x++) {
          if (groups[x].name === groupName) {
            found = true;
            GroupID = groups[x].id;
          }
        }
        if(found === false){
           GroupID = window.guide_obj.addGroup(groupName);
            let group = new Group();
            group.id = GroupID;
            group.name = groupName;
            group.poi_img = 16;
            group.mosaic = true;
            // Left unset (not the group's own filename) — this import never
            // creates a matching schedule, so setting .schedule here referenced a
            // schedule that never existed, and Home.js's mosaic-tile click handler
            // ANDs a GroupsFilter with a SchedulesFilter from this field, so every
            // tile for an imported list showed zero places. Leaving it empty routes
            // the tile through the "no linked schedule" path instead, which only
            // filters by group. Found 2026-09-27.
            window.guide_obj.modifyGroup(group, group);
        }
      }
        SetGroupID(GroupID);
        setVisited(visited);
      setTimeout(() => getMoreInfoPost(glist, GroupID, visited, bucketlist, filename), 100);
  }

  const getMoreInfoPost = async (glist, GroupID, visited, bucketlist, location = "") => {
    try {
      let groups = [];
      if (GroupID !== 0) groups.push(GroupID);

      const gp = new GooglePlaces();
      let searched = 0;
      setImportProgress(`Finding places… (0 of ${glist.length})`);
      const requests = glist.map((entry) => new Promise((resolve) => {
        const searchTerm = location ? `${entry.Title} ${location}` : entry.Title;
        gp.searchPlacesNewAPI(searchTerm, null, 0, 0, 50000, (places) => {
          searched++;
          setImportProgress(`Finding places… (${searched} of ${glist.length})`);
          resolve({ entry, places });
        }, false, AICategories, AIBaseCategories);
      }));

      const results = await Promise.all(requests);

      const newPlaces = [];
      for (const { entry, places } of results) {
        if (!places || places.length === 0) continue;
        const gplace = places[0];
        const lat = gplace.Lat;
        const lng = gplace.Longi;
        if (lat == null || lng == null) continue;

        // gplace already carries a resolved category (searchPlacesNewAPI
        // above is now passed AICategories/AIBaseCategories) and, when
        // PLACES_PROVIDER_ORDER's active provider is hasdata/openwebninja,
        // real openingHours parsed straight from the search response — both
        // were being silently discarded here before, leaving every imported
        // place uncategorized with fake "always open" hours despite the
        // search having already resolved real data. addPlaceToMap
        // (MobileBottomNavBar.js/HomeHeader.js) already merges these
        // straight through when present. Found 2026-09-26 auditing
        // search-then-enrich skip logic; same fix as mobile's KMLInput.js.
        const new_place = props.add_place_to_map("Icon", { Lat: lat, Longi: lng }, null, {
          name: entry.Title,
          info: entry.Note || "",
          group: groups,
          visited: visited,
          bucketList: bucketlist,
          category: gplace.Category,
          openingHours: gplace.OpeningHours,
        });
        if (new_place === null) continue;
        // gplace may already carry a REAL photo — unlike Google's own
        // parseNewAPIPlace (which never sets one, cost-control), HasData's/
        // OpenWeb Ninja's parsers do set place.Photo/Photo_m directly from
        // the vendor's own listing photo when PLACES_PROVIDER_ORDER's
        // active provider is one of those two. Carried through below so the
        // photo step can use it directly instead of paying for a second
        // lookup for data already in hand — still needs to run through
        // processImages either way, since that's also what sets Hlink and
        // builds this place's html_entries card for the generated page.
        if (entry.URL) newPlaces.push({ entry, new_place, gplace });
      }

      if (newPlaces.length > 0) {
        let fetched = 0;
        setImportProgress(`Fetching photos… (0 of ${newPlaces.length})`);
        await Promise.all(newPlaces.map(({ entry, new_place, gplace }) => new Promise((resolve) => {
          const params = { id: new_place.ID, link: entry.URL };
          const done = () => {
            fetched++;
            setImportProgress(`Fetching photos… (${fetched} of ${newPlaces.length})`);
            resolve();
          };
          // gplace may already carry a real photo (HasData/OpenWeb Ninja
          // set it directly from the vendor's own listing — see the
          // comment where newPlaces is built) — reuse it instead of paying
          // for a second lookup. Still routed through processImages so
          // Hlink/html_entries get built the same way either path does.
          // Found 2026-09-26 auditing search-then-enrich skip logic.
          if (hasRealPhoto(gplace)) {
            processImages([{ url: gplace.Photo, url_m: gplace.Photo_m }], params);
            done();
            return;
          }
          // Tried first now that OpenWeb Ninja/HasData is a paid subscription
          // (PLACES_PROVIDER, matching PlaceMenu.js's _autoSetPhotoSearch);
          // falls back to the pre-existing free Custom Search chain on a
          // miss. Added 2026-09-24.
          const paidSource = GooglePlaces.getPhotoProviderChain();
          const photoQuery = location ? `${entry.Title} ${location}` : entry.Title;
          paidSource.searchPlacePhoto(photoQuery, (photo) => {
            if (photo) {
              processImages([{ url: photo, url_m: photo }], params);
              done();
              return;
            }
            GoogleSearch.searchImages(entry.Title, (imageList, cbParams) => {
              processImages(imageList, cbParams);
              done();
            }, params);
          }, new_place.Lat, new_place.Longi);
        })));
      }

      setTimeout(() => createMainPage(glist), 100);
      if (newPlaces.length > 0) dispatch(slice1Actions.setCurrentAppScreen({ value: "Map" }));
    } catch (e) {
      console.error("getMoreInfoPost error:", e.message, e);
    }
    setImportProgress("");
    props.onHide();
  }

  const createMainPage = (glist) => {
    // for(let i = 0; i < glist.length; i++){
    //  home_page += `<a href="urllink:${glist[i].URL}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #64DB65;">${glist[i].Title}</button></a>`;
    
    
    //  home_page += `<a href="urllink:${glist[i].URL}"><button style="border: none; background: none; border-radius: 10%; font-size: 140%; padding: 5px; background-size: cover;"> <img style="border-radius: 10%;" src="https://p0.pikist.com/photos/74/730/firenze-il-duomo-cathedral-cityscape-italy-rooftops-city-building-architecture-thumbnail.jpg" width="336" height="268" /><br />Duomo</button></a>`
    
    
    
    // }
    // html_entries.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1));
    // let home_page = "";
    // for(let i = 0; i < html_entries.length; i++){
    //   home_page += html_entries[i].html;
    // }
    // window.guide_obj.document = home_page;
    // dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true, update_guide_attributes: true }));
    // dispatch(slice1Actions.resetHomeScreen({ value: null }));
    // setTimeout(updateMustSee, 1000);
        let htmlString = window.guide_obj.document;
        const it = window.guide_obj.guide_settings.itinerary;
        if(it.directions === false && it.info === false &&  it.photo === true && it.place_menu === false)
          htmlString = window.guide_obj.createHTMLItinerary("Main", it);
        //dispatch(slice1Actions.setHTMLTitle({ value: "Itinerary" }));
        dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
        dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
        //dispatch(slice1Actions.setShowHTMLReader({ value: true }));
        //dispatch(slice1Actions.resetHTMLScreen());
  }








  const getTimelineDays = (timeline) => {
    if(typeof timeline.semanticSegments === "undefined")
    {
      alert("Not a valid timeline file");
      console.log(timeline);
      return(0);
    }
    let dates = [];
    //let Years = [];
    
    for (let i = 0; i < timeline.semanticSegments.length-1; i++) 
    {
      if(typeof timeline.semanticSegments[i].startTime !== "undefined"){
        let startTime = timeline.semanticSegments[i].startTime;
        let day = new Date(startTime);
        day.setMinutes(day.getMinutes() + day.getTimezoneOffset());
        day.setHours(0);
        day.setMinutes(0);
        day.setSeconds(0);
        const dayGetTime = day.getTime();
        if(!dates.includes(dayGetTime)) 
          dates.push(dayGetTime);
      }
    }
    // for(let j = 0; j < dates.length-1; j++){
    //   let year_ = dates[j].label.split("-");
    //   if(!Years.includes(year_[0])) Years.push(year_[0]);
    // }
    console.log("dates", dates)
    // console.log("Years", Years)
    SetAllDates(dates);
    if (dates.length > 0) setCalendarDate(new Date(Math.min(...dates)));
    // SetYears(Years);
    return(dates.length)
  }
  
  const parseTimeline = (timeline, date) => {
    if(typeof timeline.semanticSegments === "undefined")
    {
      alert("Not a valid timeline file");
      console.log(timeline);
      return;
    }
    let month   = date.getUTCMonth() + 1; // months from 1-12
    let day     = date.getUTCDate();
    const year    = date.getUTCFullYear();
    const dateText = `${month}-${day}-${year}`
    const base62 = require("base62/lib/ascii");
    const geohash = require("ngeohash");
    let schedule = "";
    let scheds = window.guide_obj.schedule.geScheduleNames();
    for (let s = 1; s < 99999; s++) {
      schedule = `Itinerary${s}_${dateText}`;
      let found = false;
      for (let x = 1; x < scheds.length; x++) {
        if (schedule === scheds[x].label) found = true;
      }
      if (found === false) break;
    }
    let path_num = 0;
    let place_num = 0;
    let activity_num = 0;
    let last_place = null;
    let rounding_to = user_info.event_time_rounding;
    if (typeof rounding_to === "undefined") rounding_to = 15;
    if(month < 10) month = `0${month}`
    if(day < 10) day = `0${day}`
    const SearchDateText = `${month}-${day}-${year}`

    for (let i = 0; i < timeline.semanticSegments.length; i++) 
    {
      if(typeof timeline.semanticSegments[i].startTime !== "undefined" && typeof timeline.semanticSegments[i].endTime !== "undefined")
      { 
        let startTime = timeline.semanticSegments[i].startTime;
        let day = new Date(startTime);
        day.setMinutes(day.getMinutes() + day.getTimezoneOffset());
        day.setHours(0);
        day.setMinutes(0);
        day.setSeconds(0);
//"2023-07-26T02:34:41.000-07:00",
        // let startDateISOt = startDateISO.split("T");
        // let startDateISOm = startDateISOt[0].split("-");
        // let startDateISOc = startDateISOt[1].split(":");
        let startDateISO = timeline.semanticSegments[i].startTime;
        let startDate = DateTime.fromISO(startDateISO); //new Date(timeline.semanticSegments[i].startTime); //
        month = startDate.month;
        if(month < 10) month = `0${month}`
        day = startDate.day
        if(day < 10) day = `0${day}`
        //const startDateText = `${startDateISOm[1]}-${startDateISOm[2]}-${startDateISOm[0]}`
        const startDateText = `${month}-${day}-${startDate.year}`
        if(startDateText !== SearchDateText) continue;
        startDate = startDate.plus({minutes: startDate.offset});

        //let startDate = DateTime.fromObject({ year: startDateISOm[0], month: startDateISOm[1], day: startDateISOm[2], hour: startDateISOc[0], minute: startDateISOc[1] })
        // startDateISO = startDateISO.substring(0, startDateISO.length-5) + "00:00"
        // let _startDate = Common.JSDateFromLuxonDate(startDate);
        // _startDate.setMinutes(_startDate.getMinutes() - day.getTimezoneOffset());
        // startDate = Common.LuxonDateFromJSDate(_startDate);
        console.log("DATE COMPARE", timeline.semanticSegments[i].startTime, startDate.toISO())

        let endDateISO = timeline.semanticSegments[i].endTime;
        // let endDateISOt = endDateISO.split("T");
        // let endDateISOm = endDateISOt[0].split("-");
        // let endDateISOc = endDateISOt[1].split(":");
        //let endDate = DateTime.fromObject({ year: endDateISOm[0], month: endDateISOm[1], day: endDateISOm[2], hour: endDateISOc[0], minute: endDateISOc[1] })
        
        // let endtDateISO = timeline.semanticSegments[i].endTime;
        // endtDateISO = endtDateISO.substring(0, endtDateISO.length-5) + "00:00"
        let endDate = DateTime.fromISO(endDateISO); //new Date(timeline.semanticSegments[i].endTime); //
        endDate = endDate.plus({minutes: endDate.offset});
        // let _endDate = Common.JSDateFromLuxonDate(endDate);
        // _endDate.setMinutes(_endDate.getMinutes() - day.getTimezoneOffset());
        // endDate = Common.LuxonDateFromJSDate(_endDate);


        let points = "";
        let name = "";
        let elapsedSeconds = 0;
        let firstTimeStamp = 0;
        let info = "";
        let imgURL = "";
        let point_values = [0,0];
        let point_value = "0,0";
        let _mapCoordinate =  {
          Lat: 0,
          Longi: 0,
        };
        let location_type = null;
        if(typeof timeline.semanticSegments[i].timelinePath !== "undefined")
          location_type = "timelinePath";
        else if(typeof timeline.semanticSegments[i].activity !== "undefined")
          location_type = "activity";
        else if(typeof timeline.semanticSegments[i].visit !== "undefined")
          location_type = "visit";
        if(location_type === "timelinePath" || location_type === "activity")
        {
          const points_array = [];
          firstTimeStamp = 0;
          elapsedSeconds = 0;
          if(location_type === "timelinePath" ){
            for (let j = 0; j < timeline.semanticSegments[i].timelinePath.length; j++) 
            {
              if (typeof timeline.semanticSegments[i].timelinePath[j].time !== "undefined" && typeof timeline.semanticSegments[i].timelinePath[j].point !== "undefined") 
              //{
                points_array.push({point: timeline.semanticSegments[i].timelinePath[j].point, time: timeline.semanticSegments[i].timelinePath[j].time})
                // point_value = timeline.semanticSegments[i].timelinePath[j].point;
                // time = timeline.semanticSegments[i].timelinePath[j].time;
              //   point_values = point_value.split(",");
              //   if (firstTimeStamp === 0) firstTimeStamp = new Date(timeline.semanticSegments[i].startTime).getTime();
              //   else elapsedSeconds = (new Date(timeline.semanticSegments[i].timelinePath[j].time).getTime() - firstTimeStamp) / 1000;
              //   points +=
              //     ";" +
              //     geohash.encode(
              //       parseFloat(point_values[0]).toFixed(5),
              //       parseFloat(point_values[1]).toFixed(5)
              //     ) +
              //     "," +
              //     base62.encode(Math.round(elapsedSeconds));
              // }
              // _mapCoordinate =  {
              //   Lat: parseFloat(point_values[0]),
              //   Longi: parseFloat(point_values[1]),
              // };
            }
            if (name === "") {
              path_num+=1;
              name = "Path_" + path_num + "_" + dateText;
            }
          }
          if(location_type === "activity"){
            points_array.push({point: timeline.semanticSegments[i].activity.start.latLng, time: timeline.semanticSegments[i].startTime})
            points_array.push({point: timeline.semanticSegments[i].activity.end.latLng, time: timeline.semanticSegments[i].endTime})
            if (name === "") {
              activity_num+=1;
              name = "Activity_" + activity_num + "_" + dateText;
            }
          }
          for(let p= points_array.length-1; p >= 0 ; p--){
            point_values = points_array[p].point.split(",");
            if (firstTimeStamp === 0)  firstTimeStamp = new Date(points_array[p].time).getTime();
            else elapsedSeconds = (new Date(points_array[p].time).getTime() - firstTimeStamp) / 1000;
            points +=
              ";" +
              geohash.encode(
                parseFloat(point_values[0]).toFixed(5),
                parseFloat(point_values[1]).toFixed(5)
              ) +
              "," +
              base62.encode(Math.round(elapsedSeconds));
              _mapCoordinate =  {
                Lat: parseFloat(point_values[0]),
                Longi: parseFloat(point_values[1]),
              }
          }
          console.log("**PolyLine", "_mapCoordinate", _mapCoordinate, "points", points, "name", name );
          const new_path = props.add_place_to_map("PolyLine", _mapCoordinate, points, { name: name, info: info, imgURL: imgURL });
          addEvent(new_path, schedule, startDate, last_place, rounding_to, endDate, false);
        }
        if(location_type === "visit")
        {
          if (name === "") {
            place_num+=1;
            name = "Place_" + place_num+ "_" + dateText;
          }
          
          const place_id = timeline.semanticSegments[i].visit.topCandidate.placeId;
          const Hlink = `https://www.google.com/maps/place/?q=place_id:${place_id}`
          point_value = timeline.semanticSegments[i].visit.topCandidate.placeLocation.latLng;
          point_values = point_value.split(",");

          const point = { Lat: parseFloat(point_values[0]), Longi: parseFloat(point_values[1]) };
          const new_place = props.add_place_to_map("Icon", point, null, { name: name, info: info, imgURL: imgURL, Hlink: Hlink });
          if (new_place === null) return;
          console.log("daydate", startDate)
          addEvent(new_place, schedule, startDate, last_place, rounding_to, endDate, false);
          last_place = new_place;
        }
      }
    }
    dispatch(slice1Actions.setScheduleName({ value: schedule }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  }

  const sample_json = {
    guide: "Palermo4",
    name: "4 day Palermo itinerary",
    description: "4 day Palermo itinerary",
    schedule: "Palermo 4 days",
    image: "",
    cities: "Palermo",
    countries: "Italy",
    placemarks: [
      {
        name: "Cappella Palatina",
        categories: "Architecture,Castles,Religious sites",
        duration: 105,
        description:
          "The Palatine Chapel is the royal chapel of the Norman Palace in Palermo, Sicily. This building is a mixture of Byzantine, Norman and Fatimid … See more",
        url: "http://en.wikipedia.org/wiki/Cappella_Palatina",
        website: "https://www.cappellapalatinapalermo.it/",
        coordinates: "13.353610,38.110830",
        address: "Piazza del Parlamento, Palermo, Sicily 90134",
        country: "Italy",
        state: "Sicily",
        city: "Palermo",
        day: 1,
        image: "",
        image_t: "",
      },
    ],
  };

  let jsonfile = "";
  const parseJSON = (guide_json) => {
    let json_guide = JSON.parse(guide_json);
    let guide_attributes = JSON.parse(JSON.stringify(window.guide_obj.attributes));
    let dateGuide = DateTime.utc();
    let cur_day = 0;
    let dayDate = "";
    let last_place = null;
    let day_offset = 0;
    const sheduleMain = window.guide_obj.schedule.getScheduleToDisplay("Main");
    if (sheduleMain.length === 0) {
      day_offset = Math.floor(Math.random() * 2500);
      day_offset = day_offset - 1250;
      dateGuide = dateGuide.plus({ days: day_offset });
    } else {
      console.log(sheduleMain[0]);
      dateGuide = DateTime.fromISO(sheduleMain[0].start, {zone: 'utc'});
    }
    dateGuide = dateGuide.set({ hour: 11 });
    dateGuide = dateGuide.set({ minutes: 0 });

    if (guide_attributes.guide_name === "New Guide") {
      guide_attributes.guide_name = json_guide.name;
      guide_attributes.description = json_guide.description;
      guide_attributes.image_m = json_guide.image;
      guide_attributes.image = json_guide.image.replace(".jpg", "_t.jpg");

      //guide_attributes.language = json_guide.Language;
      //guide_attributes.rating = parseInt(json_guide.placemarks[i].Rating);
      if (!guide_attributes.countries.includes(json_guide.countries))
        guide_attributes.countries.push(json_guide.countries);
      if (!guide_attributes.cities.includes(json_guide.cities)) guide_attributes.cities.push(json_guide.cities);
    }
    for (let i = 0; i < json_guide.placemarks.length; i++) {
      if (typeof json_guide.placemarks[i].coordinates === "undefined") continue;
      if (json_guide.placemarks[i].coordinates.length !== 2) continue;
      let place = null;
      let mode = "modify";
      let existing_place = window.guide_obj.places.getPlacesFromName(json_guide.placemarks[i].name);
      if (existing_place === null) {
        place = new Place(window.guide_obj.places);
        mode = "new";
      } else place = existing_place;
      place.Name = json_guide.placemarks[i].name;
      place.Lat = json_guide.placemarks[i].coordinates[1];
      place.Longi = json_guide.placemarks[i].coordinates[0];
      place.Address = json_guide.placemarks[i].address;
      place.City = json_guide.placemarks[i].city !== "" ? json_guide.placemarks[i].city : json_guide.cities;
      place.State = json_guide.placemarks[i].state;
      place.Country = json_guide.placemarks[i].country !== "" ? json_guide.placemarks[i].country : json_guide.countries;
      place.Hlink = json_guide.placemarks[i].url;
      place.Photo = json_guide.placemarks[i].image_t;
      place.Photo_m = json_guide.placemarks[i].image;
      let info = json_guide.placemarks[i].description.replace(" … See more", "").replace("…", "");
      if (info.length > 200) info = info.substring(0, 149);
      place.Info = `<p style="text-align:center;"><img src="${place.Photo_m}" alt="Image" style="width:100%; max-width:700px; height:auto; border-radius:10%" data-photo="${place.Photo}" onerror="window.imgFallback(this)"></img></p>${info}<a href="urllink:${place.Hlink}"> ... See More.</a><br>`;

      // place.Info = `<img src="${place.Photo}" alt="Image" style="float: left;
      // margin: 10px; width:350px; border-radius:10%" ></img><p style="margin: 10px;">${info}<a href="urllink:${place.Hlink}">... See More.</a></p><br style="clear:both;">`;
      place.PType = "Icon";
      for (let j = 0; j < json_guide.placemarks[i].categories.length; j++) {
        const this_category = json_guide.placemarks[i].categories[j];
        if (this_category === "") continue;
        let cat = window.guide_obj.getCategoryByName(this_category, "guide");
        if (cat !== null) {
          if (!place.Category.includes(cat.id)) place.Category.push(cat.id);
        } else {
          cat = window.guide_obj.getCategoryByName(this_category, "initial");
          if (cat !== null) {
            let cat2 = window.guide_obj.getCategoryByName(cat.name, "guide");
            if (cat2 === null) {
              window.guide_obj.addCategory(this_category);
              let catg = window.guide_obj.getCategoryByName(this_category, "guide");
              if (catg !== null) {
                window.guide_obj.modifyCategory(catg, cat);
                if (!place.Category.includes(catg.id)) place.Category.push(catg.id);
              }
            } else {
              if (!place.Category.includes(cat2.id)) place.Category.push(cat2.id);
            }
          } else console.log(`Category not found: ${this_category}`);
        }
      }
      // We don't need a group, each attraction is part of one or more schedules
      // let group = window.guide_obj.getGroupByName(json_guide.guide, "guide");
      // if (group !== null) {
      //   if (!place.Group.includes(group.id)) place.Group.push(group.id);
      // } else {
      //   // if (!place.Group.includes(group.id)) {
      //   window.guide_obj.addGroup(json_guide.guide);
      //   let group = window.guide_obj.getGroupByName(json_guide.guide, "guide");
      //   if (group !== null) {
      //     group.name = json_guide.guide;
      //     group.poi_img = "152";
      //     place.Group.push(group.id);
      //     window.guide_obj.modifyGroup(group, group);
      //   }
      //   // }
      // }
      if (mode === "new") window.guide_obj.places.addPlace(place);
      else window.guide_obj.places.modifyPlace(place, place.ID);
      // Dont add place in schedule
      if (json_guide.placemarks[i].day === 0) continue;
      mode = "modify";
      let event = null;
      let existing_event = window.guide_obj.schedule.findEventByName(json_guide.placemarks[i].name, sample_json.guide);
      if (existing_event === null) {
        event = new Appointment(window.guide_obj.schedule);
        mode = "new";
      } else event = existing_event;
      // let total_minutes = 0
      // for(let d = 0; d < json_guide.placemarks.length && d <= i; d++) total_minutes+=
      if (cur_day !== json_guide.placemarks[i].day) {
        last_place = null;
        dayDate = dateGuide.plus({ days: json_guide.placemarks[i].day });
        cur_day = json_guide.placemarks[i].day;
      }
      event.Subject = json_guide.placemarks[i].name;
      event.Body = ""; //place.Info;
      event.Itinerary = json_guide.schedule;
      // Unlike this file's other rounding_to reads, this one had no fallback
      // at all — an undefined user_info.event_time_rounding (e.g. a legacy
      // account) fed straight into Common.estimateTravelTimeMinutes's
      // Math.round(t / rounding_to), producing NaN travel times. Fixed
      // 2026-09-13, matching the fallback every other site in this file uses.
      let rounding_to = typeof user_info.event_time_rounding === "undefined" ? 15 : user_info.event_time_rounding;
      let travel_time = last_place !== null ? Common.estimateTravelTimeMinutes(last_place, place, rounding_to) : 0;
      last_place = place;
      dayDate = dayDate.plus({ minutes: travel_time });
      event.Start = dayDate.toISO(); //({ zone: "utc" });
      dayDate = dayDate.plus({ minutes: json_guide.placemarks[i].duration });
      event.End = dayDate.toISO(); //({ zone: "utc" });
      if (!event.Places.includes(place.ID)) event.Places = place.ID;
      if (mode === "new") window.guide_obj.schedule.addEvent(event);
      else window.guide_obj.schedule.modifyEvent(event);
    }
    //if (sheduleMain.length === 0) window.guide_obj.schedule.copySchedule(json_guide.schedule, "Main");
    //let GuideSettings = useSelector((state) => state.GuideSettings);
    let GuideSettings = {
      mode: "edit", // "edit" "view" "custom_view"
      zoom: 5,
      hide_schedule: false,
      hide_hidden: false,
      wrap_text: false,
      places_list: {
        menu: false,
        info: true,
        url: false,
        attributes: true,
        center: false,
        filter: false,
        path_link: false,
      },
      places_map: {
        menu: true,
        info: false,
        url: false,
        attributes: false,
        center: false,
        filter: false,
        path_link: false,
      },
      places_map_hover: {
        menu: false,
        place: true,
        info: true,
        event: true,
        path_link: false,
      },
      event: {
        menu: true,
        details: false,
        center: false,
        filter: false,
      },
      schedule: {
        menu: true,
        itinerary: false,
        center: false,
        filter: false,
      },
      day: {
        menu: true,
        center: false,
        filter: false,
      },
      itinerary: {
        directions: true,
        info: true,
        photo: false,
        place_menu: true,
      },
    };
    //GuideSettings.mode = "custom_view";
    dispatch(slice1Actions.setGuideSettings({ value: GuideSettings }));
    let scheds = window.guide_obj.schedule.geScheduleNames(); //JSON.parse(JSON.stringify(ScheduleNames));
    //scheds.push({ label: json_guide.schedule });
    scheds = scheds.sort((a, b) => (a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1));
    let days = [];
    let labels = [];
    for (let s = 0; s < scheds.length; s++) {
      const scheds_parts = scheds[s].label.split(" ");
      const length = scheds_parts.length;
      if (length >= 3) {
        labels.push({ sched: scheds[s].label, label: `${scheds_parts[length - 2]} ${scheds_parts[length - 1]}` });
        days.push(parseInt(scheds_parts[length - 2]));
      }
    }
    let continuos = true;
    for (let n = 0; n < days.length - 1; n++) {
      if (days[n + 1] !== days[n] + 1) continuos = false;
    }
    let title = `${json_guide.cities} `;

    if (continuos) {
      if (days.length > 1) title = `${json_guide.cities} ${days[0]}-${days[days.length - 1]}`;
      else title = `${json_guide.cities} ${days[0]}`;
    } else
      for (let n = 0; n < days.length; n++) {
        title += `${days[n]}${n < days.length - 1 ? "," : ""}`;
      }
    title += days.length > 2 ? " days" : " day";
    const desc = title + " itinerary";

    let center = { latitude: 0, longitude: 0 };
    if (typeof json_guide.coordinates !== "undefined" && typeof json_guide.coordinates !== "") {
      //MapCenter = { lat: json_guide.coordinates[1], lng: json_guide.coordinates[0] };
      center = { latitude: json_guide.coordinates[1], longitude: json_guide.coordinates[0] };
      guide_attributes.base_location = { latitude: json_guide.coordinates[1], longitude: json_guide.coordinates[0] };
    } else {
      const weighted_center = window.guide_obj.places.getWeightedCenter(null);
      center = { latitude: weighted_center.lat, longitude: weighted_center.lon };
      guide_attributes.base_location = { latitude: weighted_center.lat, longitude: weighted_center.lon };
    }

    window.guide_obj.schedule.deleteAllEvents("Main");
    if (scheds.length > 1) window.guide_obj.schedule.copySchedule(scheds[scheds.length - 2].label, "Main");
    guide_attributes.guide_name = title;
    guide_attributes.description = desc;
    guide_attributes.access = ["Featured", "All_C"];
    guide_attributes.type = "Featured";
    window.guide_obj.attributes.modifyGuideAttributes(guide_attributes);

    let home_page = `<p style="text-align:center;"><img src="${json_guide.image}" alt="Image" style="width:100%; max-width:700px; height:auto; border-radius:10%" ></img></p>`;
    home_page += `<p><h3 style="text-align:center;">${title}</h3></p></br>`;

    if (typeof json_guide.info !== "undefined")
      home_page += `<a href="urllink:${json_guide.info}">General info for ${json_guide.cities}</a><br><br>`;

    //if (labels.length > 0) home_page += `<span><b>Show Schedule for:</b></span><br>`;
    // for (let i = 0; i < labels.length; i++) {
    //   if (labels[i].label === "Main") continue;
    //   home_page += `<a href="schedulelink:${labels[i].sched}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #FEC02D;">${labels[i].label}</button></a>`;
    //   //home_page += `<a href="schedulelink:${scheds[i].label}">Show schedule for "${scheds[i].label}"</a><br>`;
    // }
    // home_page += `<br>`;

    if (labels.length > 0) home_page += `<span><b>Show Itinerary for:</b></span><br>`;
    for (let i = 0; i < labels.length; i++) {
      if (labels[i].label === "Main") continue;
      home_page += `<a href="itinerarylink:${labels[i].sched}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #36D1E5;">${labels[i].label}</button></a>`;
      // home_page += `<a href="itinerarylink:${scheds[i].label}">Show itinerary for "${scheds[i].label}"</a><br>`;
    }
    home_page += `<br>`;
    home_page += `<span><b>Internet Resources:</b></span><br>`;
    if (typeof json_guide.weather !== "undefined" && last_place !== null)
      //home_page += `<a href="weatherlink:${last_place.ID}">Show weather forecast for "${json_guide.cities}"</a><br><br>`;
      home_page += `<a href="weatherlink:${last_place.ID}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #64DB65;">Weather</button></a>`;

    if (typeof json_guide.climate !== "undefined")
      //home_page += `<a href="urllink:${json_guide.climate}">Show yearly climate for ${json_guide.cities}</a><br>`;
      home_page += `<a href="urllink:${json_guide.climate}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #64DB65;">Climate</button></a>`;

    const videos = `https://www.youtube.com/results?search_query=${json_guide.cities}+${json_guide.countries}+attractions`;
    home_page += `<a href="urllink:${videos}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #64DB65;">Videos</button></a>`;
    const articles = `http://www.google.com/search?q=${json_guide.cities}+${json_guide.countries}+Travel+Itinerary`;
    home_page += `<a href="urllink:${articles}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #64DB65;">Articles</button></a>`;

    if (last_place !== null) {
      //home_page += `<a href="urllink:https://www.yelp.com/search?find_loc=${center.latitude},${center.longitude}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #64DB65;">Yelp</button></a>`;
      home_page += `<a href="urllink:https://www.happycow.net/searchmap?s=3&location=&filters=vegan-vegetarian-vegfriendly&metric=mi&limit=81&order=default&lat=${center.latitude}&lng=${center.longitude}&zoom=15&page=1"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #64DB65;">Vegan</button></a>`;
      home_page += `<a href="urllink:http://maps.google.com/maps?q=${center.latitude},${center.longitude}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #64DB65;">Google Maps</button></a>`;
    }

    home_page += `<br><br><p><span style="font-size: 60%;">Credits: Itineraries from <a href="urllink:https://www.bing.com/maps/">Bing Maps</a>. Attraction info and images from <a href="urllink:https://www.wikipedia.org/">Wikipedia</a>. Under the CC BY-SA licensing agreement</span></p>`;

    window.guide_obj.document = home_page;
    // if (window.guide_obj.document === "") {
    //   const itinerary = window.guide_obj.createHTMLItinerary(json_guide.schedule, GuideSettings.itinerary);
    //   window.guide_obj.document = itinerary;
    // }
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true, update_guide_attributes: true }));
    dispatch(slice1Actions.resetHomeScreen({ value: null }));
    setTimeout(updateMustSee, 200);
  };
  const updateMustSee = () => {
    const countTimesInSchedule = window.guide_obj.schedule.countTimesInSchedule();
    let scheds = window.guide_obj.schedule.geScheduleNames();
    console.log("countTimesInSchedule", countTimesInSchedule);
    for (let i = 0; i < countTimesInSchedule.length; i++) {
      const place = window.guide_obj.places.getPlace(countTimesInSchedule[i].placeID);
      if (place === null) continue;
      place.MustSee = countTimesInSchedule[i].count >= (scheds.length - 1) / 2;
      window.guide_obj.places.modifyPlace(place, place.ID);
    }

    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true, update_guide_attributes: true }));
  };
  
  // mode: "create" = new group, all places added
  //       "merge"  = existing group, skip places that already exist by name
  //       "new"    = new unique group, skip existing by name but add new groupID to them
  const doParseGeoJSON = (geoJson, groupID, mode) => {
    const base62 = require("base62/lib/ascii");
    const geohash = require("ngeohash");
    let schedule = "";
    let scheds = window.guide_obj.schedule.geScheduleNames();
    for (let s = 1; s < 99999; s++) {
      schedule = `Itinerary${s}`;
      let found = false;
      for (let x = 1; x < scheds.length; x++) {
        if (schedule === scheds[x].label) found = true;
      }
      if (found === false) break;
    }

    const groupParam = groupID > 0 ? [groupID] : undefined;

    // Returns true if the place already exists and we should skip creating it.
    // For "new" mode also stamps the new groupID onto the existing place.
    const skipExisting = (name) => {
      if (mode === "create" || !name) return false;
      const existing = window.guide_obj.places.getPlacesFromName(name);
      if (existing === null) return false;
      if (mode === "new" && groupID > 0 && !existing.Group.includes(groupID)) {
        existing.Group.push(groupID);
        window.guide_obj.places.modifyPlace(existing, existing.ID);
      }
      return true;
    };

    let dateGuide = DateTime.utc();
    dateGuide = dateGuide.set({ hour: 11 });
    dateGuide = dateGuide.set({ minutes: 0 });
    let dayDate = dateGuide;
    let last_place = null;
    let rounding_to = user_info.event_time_rounding;
    if (typeof rounding_to === "undefined") rounding_to = 15;
    // try {
    for (let i = 0; i < geoJson.features.length; i++) {
      let placeMark = geoJson.features[i];
      let name = placeMark.properties.name;
      let info = placeMark.properties.description;
      if (typeof name === "undefined") name = "";
      if (typeof info === "undefined") info = "";
      let imgURL = "";
      if (placeMark.properties.title != null && typeof placeMark.properties.title !== "undefined")
        name = placeMark.properties.title;
      if (placeMark.properties.time != null && typeof placeMark.properties.time !== "undefined")
        info += "time: " + placeMark.properties.time;
      if (placeMark.properties.ascent != null && typeof placeMark.properties.ascent !== "undefined")
        info += " ascent: " + placeMark.properties.ascent + "m";
      if (placeMark.properties.descent != null && typeof placeMark.properties.descent !== "undefined")
        info += " descent: " + placeMark.properties.descent + "m";
      if (placeMark.properties.imgURL != null && typeof placeMark.properties.imgURL !== "undefined")
        imgURL = placeMark.properties.imgURL;

      // Round-trip fields written by our own Guide.createKML() ExtendedData
      // (see _placeExtendedDataKML) — absent/blank on KML from other tools,
      // which is fine since every read here is optional.
      const kmlProps = placeMark.properties;
      const extraParams = {
        imgURL: kmlProps.imgURLFull || imgURL,
        imgURL_t: imgURL,
        address: kmlProps.address || "",
        city: kmlProps.city || "",
        state: kmlProps.state || "",
        country: kmlProps.country || "",
        phone: kmlProps.phone || "",
        email: kmlProps.email || "",
        rating: kmlProps.rating || "",
        duration: kmlProps.duration ? parseInt(kmlProps.duration) : 30,
        Hlink: kmlProps.hlink || "",
        poi_img: kmlProps.poiImg || "0",
        favorite: kmlProps.favorite === "true",
        visited: kmlProps.visited === "true",
        mustSee: kmlProps.mustSee === "true",
        hidden: kmlProps.hidden === "true",
      };
      try {
        if (kmlProps.link) extraParams.link = JSON.parse(kmlProps.link);
      } catch {}
      try {
        if (kmlProps.openingHours) extraParams.openingHours = JSON.parse(kmlProps.openingHours);
      } catch {}
      const kmlGroupIds = [];
      if (kmlProps.groups) {
        kmlProps.groups.split("||").map(n => n.trim()).filter(Boolean).forEach(groupName => {
          let g = window.guide_obj.getGroupByName(groupName, "guide");
          const gid = g ? g.id : window.guide_obj.addGroup(groupName);
          if (!kmlGroupIds.includes(gid)) kmlGroupIds.push(gid);
        });
      }
      const kmlCategoryIds = [];
      if (kmlProps.categories) {
        kmlProps.categories.split("||").map(n => n.trim()).filter(Boolean).forEach(catName => {
          let c = window.guide_obj.getCategoryByName(catName, "guide");
          const cid = c ? c.id : window.guide_obj.addCategory(catName);
          if (!kmlCategoryIds.includes(cid)) kmlCategoryIds.push(cid);
        });
      }
      if (kmlCategoryIds.length > 0) extraParams.category = kmlCategoryIds;
      const mergedGroupParam = [...(groupParam || []), ...kmlGroupIds];
      if (mergedGroupParam.length > 0) extraParams.group = mergedGroupParam;

      if (placeMark.geometry != null)
      {
        if (placeMark.geometry.type === "Point") {
          if (skipExisting(name)) continue;
          const point = { Lat: placeMark.geometry.coordinates[1], Longi: placeMark.geometry.coordinates[0] };
          const new_place = props.add_place_to_map("Icon", point, null, { name: name, info: info, ...extraParams });

          if (new_place === null) return;
          dayDate = addEvent(new_place, schedule, dayDate, last_place, rounding_to);
          last_place = new_place;
        } else if (placeMark.geometry.type === "LineString") {
          if (true === false) {
            let points = "";
            for (let j = 0; j < placeMark.geometry.coordinates.length; j++) {
              if (points !== "") points += ":";
              points += placeMark.geometry.coordinates[j][0] + "," + placeMark.geometry.coordinates[j][1];
            }
            const _mapCoordinate = {
              Lat: placeMark.property.coordinates[0][1],
              Longi: placeMark.geometry.coordinates[0][0],
            };
            if (name === "") name = "New Path";
            if (!skipExisting(name))
              props.add_place_to_map("PolyLine", _mapCoordinate, points, { name: name, info: info, imgURL: imgURL, group: groupParam });
          } else {
            let points = "";
            let times = [];
            if (typeof placeMark.properties.coordinateProperties !== "undefined")
              if (typeof placeMark.properties.coordinateProperties.times !== "undefined")
                times = placeMark.properties.coordinateProperties.times;
            let time = null;

            let elapsedSeconds = 0;
            let firstTimeStamp = 0;
            for (let j = 0; j < placeMark.geometry.coordinates.length; j++) {
              if (typeof times[j] !== "undefined") {
                time = times[j];
                if (firstTimeStamp === 0) firstTimeStamp = new Date(time).getTime();
                else elapsedSeconds = (new Date(time).getTime() - firstTimeStamp) / 1000;

                //firstTimeStamp = time;
                //console.log("new Date(time)", new Date(time), new Date(time).getTime());
                //if (points !== "") points += ":";
                //points += placeMark.geometry.coordinates[j][0] + "," + placeMark.geometry.coordinates[j][1];
                console.log(placeMark.geometry.coordinates[j]);
                points +=
                  ";" +
                  geohash.encode(
                    parseFloat(placeMark.geometry.coordinates[j][1]).toFixed(5),
                    parseFloat(placeMark.geometry.coordinates[j][0]).toFixed(5)
                  ) +
                  "," +
                  base62.encode(Math.round(elapsedSeconds));
                // let alt = Math.round(placeMark.geometry.coordinates[j][2] * 10);
                // points += "," + base62.encode(alt);
              } else {
                if (points !== "") points += ":";
                points += placeMark.geometry.coordinates[j][0] + "," + placeMark.geometry.coordinates[j][1];
              }
            }
            const _mapCoordinate = {
              Lat: placeMark.geometry.coordinates[0][1],
              Longi: placeMark.geometry.coordinates[0][0],
            };
            if (name === "") name = "New Path";
            if (!skipExisting(name))
              props.add_place_to_map("PolyLine", _mapCoordinate, points, { name: name, info: info, ...extraParams });
          }
        } else if (placeMark.geometry.type === "Polygon") {
          let points = "";

          for (let j = 0; j < placeMark.geometry.coordinates[0].length; j++) {
            if (points !== "") points += ":";
            points += placeMark.geometry.coordinates[0][j][0] + "," + placeMark.geometry.coordinates[0][j][1];
          }
          const _mapCoordinate = {
            Lat: placeMark.geometry.coordinates[0][0][1],
            Longi: placeMark.geometry.coordinates[0][0][0],
          };
          if (name === "") name = "New Area";
          if (!skipExisting(name))
            props.add_place_to_map("Polygon", _mapCoordinate, points, { name: name, info: info, ...extraParams });
        }

      }
    }
    dispatch(slice1Actions.setScheduleName({ value: schedule }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
    // } catch (e) {
    //   alert(e.message);
    // }
  };

  // Returns true when showing a prompt so the caller defers props.onHide().
  const parseGeoJSON = (geoJson, fileNameBase) => {
    if (typeof geoJson.features === "undefined") return false;

    if (!fileNameBase) {
      doParseGeoJSON(geoJson, 0, "create");
      return false;
    }

    const existingGroup = window.guide_obj.findGroupFromName(fileNameBase);
    if (!existingGroup) {
      const newGroupID = window.guide_obj.addGroup(fileNameBase);
      doParseGeoJSON(geoJson, newGroupID, "create");
      return false;
    }

    myConfirm(
      `A group named "${fileNameBase}" already exists. What would you like to do?`,
      [
        {
          Title: "Merge",
          Method: () => { doParseGeoJSON(geoJson, existingGroup.id, "merge"); props.onHide(); },
        },
        {
          Title: "Create another group",
          Method: () => {
            let uniqueName = fileNameBase;
            let counter = 2;
            while (window.guide_obj.findGroupFromName(uniqueName) !== null) {
              uniqueName = `${fileNameBase} ${counter++}`;
            }
            const newGroupID = window.guide_obj.addGroup(uniqueName);
            doParseGeoJSON(geoJson, newGroupID, "new");
            props.onHide();
          },
        },
        { Title: "Cancel", Method: () => props.onHide() },
      ]
    );
    return true; // caller must NOT call props.onHide() — we own it now
  };

  const addEvent = (place, Itinerary, startDate, last_place, rounding_to, endDate, travel_duration) => {
    //console.log("addEvent startDate", startDate.toISO());
    //console.log("addEvent endDate", endDate.toISO());
    
    let calculatedEND = endDate;
    let travel_time = 0;
    if (last_place !== null && travel_duration !== false) {
      travel_time = Common.estimateTravelTimeMinutes(last_place, place, rounding_to);
      calculatedEND = startDate.plus({ minutes: travel_time });
      calculatedEND = calculatedEND.plus({ minutes: place.Duration });
    }
    let event = new Appointment(window.guide_obj.schedule);
      event.Start = startDate.toISO();
      event.End = event.Start;
      try{
      if(typeof endDate !== "undefined") event.End = endDate.toISO();
    }
    catch{
      if(typeof calculatedEND !== "undefined") event.End = calculatedEND.toISO();
    }
    event.Subject = place.Name;
    event.Body = "";
    event.Itinerary = Itinerary;
    event.Places = place.ID;
    window.guide_obj.schedule.addEvent(event);
    return startDate;
  };

  // const writeFile = () => {
  //   const fs = require("fs");
  //   const content = "Some content!";
  //   fs.writeFile("../../Guides/Rome.txt", content, (err) => {
  //     if (err) {
  //       console.error(err);
  //       return;
  //     }
  //     //file written successfully
  //   });
  // };

  // if (ShowMultiselect)
  //   return (
  //     <MultiSelectModal
  //       show={ShowMultiselect}
  //       onHide={() => dispatch(slice1Actions.setShowMultiselect({ value: false }))}
  //       MultiselectItems={MultiselectItems}
  //       MultiselectSelectedItems={MultiselectSelectedItems}
  //       MultiselectMode={MultiselectMode}
  //       MultiselectCallback={MultiselectCallback}
  //       MultiselectTitle={MultiselectTitle}
  //       MultiselectSearchText={MultiselectSearchText}
  //     />
  //   );
  // else {

    // const [startDate, setStartDate] = useState(new Date());
    // const months = [
    //   "January",
    //   "February",
    //   "March",
    //   "April",
    //   "May",
    //   "June",
    //   "July",
    //   "August",
    //   "September",
    //   "October",
    //   "November",
    //   "December",
    // ];

    //const disabledDates = [tomorrow, in3Days, in5Days];

  function tileDisabled({ date, view }) {
    // Disable tiles in month view only
    if (view === 'month') {
      // Check if a date React-Calendar wants to check is on the list of disabled dates
      return(!AllDates.includes(date.getTime()));
    }
  }
  const onCalendarChange = (date) => {
    console.log(date);
    parseTimeline(TimeLineJSON, date);
    dispatch(slice1Actions.setCurrentAppScreen({ value: "Map" }));
    props.onHide();
  }
  const [calendarDate, setCalendarDate] = useState(new Date());
  
  const acceptTypes =
    props.file_type === "KML" ? ".kml,.kmz,.gpx,.tcx" :
    props.file_type === "CSV" ? ".csv" : ".json";

  return (
    <div className="modal">
      {/* Hidden file input — always in DOM so the auto-open useEffect can click it */}
      <input
        ref={fileInputRef}
        type="file"
        accept={acceptTypes}
        onChange={upload}
        id="file-upload"
        multiple
        style={{ display: "none" }}
      />

      {/* Calendar dialog — only shown for JSON timeline after dates are loaded */}
      {props.file_type === "JSON" && AllDates.length > 0 && (
        <Modal
          {...props}
          dialogClassName="ki-dialog"
          aria-labelledby="ki-title"
          centered={false}
          scrollable={false}
          fade={false}
          onHide={() => props.onHide()}
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="ki-shell">

              {/* ── Header ── */}
              <div className="ki-header">
                <div className="ki-header-icon">
                  <FontAwesomeIcon icon={solid("calendar-days")} />
                </div>
                <h2 className="ki-title" id="ki-title">Select Date</h2>
                <button className="ki-close" onClick={props.onHide}>
                  <FontAwesomeIcon icon={solid("xmark")} />
                </button>
              </div>

              {/* ── Body ── */}
              <div className="ki-body">
                <div className="ki-calendar-section">
                  <div className="ki-section-label">Pick a day to import</div>
                  <Calendar
                    onChange={onCalendarChange}
                    value={calendarDate}
                    tileDisabled={tileDisabled}
                  />
                </div>
              </div>

              {/* ── Footer ── */}
              <div className="ki-footer">
                <button className="ki-cancel-btn" onClick={props.onHide}>Cancel</button>
              </div>

            </div>
          </Modal.Body>
        </Modal>
      )}

      <AlertModal
        show={AlertModalShow}
        onHide={() => setAlertModalShow(false)}
        AlertModalTitle={AlertModalTitle}
        AlertModalMessage={AlertModalMessage}
        AlertModalButtons={AlertModalButtons}
      />

      {ImportOptionsShow && (
        <Modal
          show={ImportOptionsShow}
          dialogClassName="ki-dialog"
          aria-labelledby="ki-import-options-title"
          centered
          animation={false}
          onHide={() => setImportOptionsShow(false)}
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="ki-shell">

              <div className="ki-header">
                <div className="ki-header-icon">
                  <FontAwesomeIcon icon={solid("list-check")} />
                </div>
                <h2 className="ki-title" id="ki-import-options-title">Import Options</h2>
                <button className="ki-close" onClick={() => setImportOptionsShow(false)}>
                  <FontAwesomeIcon icon={solid("xmark")} />
                </button>
              </div>

              <div className="ki-body">
                <label style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                  <input type="checkbox" checked={optVisited} onChange={(e) => setOptVisited(e.target.checked)} />
                  Mark places as visited
                </label>
                <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <input type="checkbox" checked={optBucketList} onChange={(e) => setOptBucketList(e.target.checked)} />
                  Add to Bucket List
                </label>
              </div>

              <div className="ki-footer">
                <button className="ki-cancel-btn" onClick={handleImportOptionsContinue}>Continue</button>
              </div>

            </div>
          </Modal.Body>
        </Modal>
      )}

      {ImportProgress && (
        <Modal show={!!ImportProgress} dialogClassName="ki-dialog" centered animation={false} backdrop="static" onHide={() => {}}>
          <Modal.Body style={{ padding: 0 }}>
            <div className="ki-shell">
              <div className="ki-body" style={{ textAlign: "center", padding: "24px" }}>
                {ImportProgress}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
// };
};

export default KMLInput;
